import Alpine from 'alpinejs'

Alpine.data('searchSuggest', (currentQuery: string) => ({

    query : currentQuery,
    suggestQuery: '',

    showSuggest: false,
    suggestFetching: false,
    
    eventTimeout: null,

    init() {
        this.$watch('query', () => {
            this.updateSuggest()
        })
        this.$watch('showSuggest', (value) => {
            if(value) {
                this.$dispatch('search-suggest-show')
            } else {
                this.$dispatch('search-suggest-hide')
            }
        })
    },

    focus() {
        if(this.query !== '') {
            // if query was injected server side, call initial updateSuggest on focus
            if(this.suggestQuery !== this.query) {
                this.updateSuggest()
            }
            this.showSuggest = true
            this.$dispatch('search-suggest-show')
        }
    },

    trackSearch() {
        if(this.query === '') {
            return
        }
        if(this.eventTimeout) {
            window.clearTimeout(this.eventTimeout)
        }
        const query = this.query
        this.eventTimeout = window.setTimeout(function() {
            window.gtag('event', 'search', { 'search_term' : query })
        }, 1000)
    },

    clearSearch() {
        this.query = ''
    },

    updateSuggest() {
        if(this.suggestFetching) {
            return
        }
        if(this.query === '') {
            this.suggestQuery = ''
            this.showSuggest = false
            return
        }
        this.suggestQuery = this.query
        this.suggestFetching = true

        const formData = new FormData()
        formData.append('query', this.query)

        fetch('/search/suggest', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(formData)
        })
            .then(response => response.json())
            .then((json) => {
                try {
                    Alpine.morph(this.$refs.suggestResultTemplate.firstChild, json.htmlFragment)
                    this.showSuggest = true
                    this.trackSearch()
                } catch(error) {
                    console.log(error)
                }
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                this.suggestFetching = false
                if(this.query !== this.suggestQuery) {
                    this.updateSuggest()
                }
            })
    }
}))